import { render, staticRenderFns } from "./NotAllowedReason.vue?vue&type=template&id=74a38960&scoped=true"
import script from "./NotAllowedReason.vue?vue&type=script&setup=true&lang=js"
export * from "./NotAllowedReason.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NotAllowedReason.vue?vue&type=style&index=0&id=74a38960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a38960",
  null
  
)

export default component.exports